export default __webpack_public_path__ + "static/media/drbarkers.5b377f22.png";